(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["static-small-slideshow-en"] && !Shopify.designMode) return;
  try {
    
var menu_items = document.querySelectorAll('.small-slideshow-menu-item'),
    sss_flickity = window.sss.flickity,
    i;

for (i = 0; i < menu_items.length; i++) {
  menu_items[i].addEventListener('click', function() {
    sss_flickity.select(this.dataset['pageDot']);
  });
}

sss_flickity.on('change', function() {
  var selectedIndex = sss_flickity.selectedIndex;
  for (i = 0; i < menu_items.length; i++) {
    menu_items[i].classList.remove('active');
  }
  menu_items[selectedIndex].classList.add('active');
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-small-slideshow"] && !Shopify.designMode) return;
  try {
    
var menu_items = document.querySelectorAll('.small-slideshow-menu-item'),
    sss_flickity = window.sss.flickity,
    i;

for (i = 0; i < menu_items.length; i++) {
  menu_items[i].addEventListener('click', function() {
    sss_flickity.select(this.dataset['pageDot']);
  });
}

sss_flickity.on('change', function() {
  var selectedIndex = sss_flickity.selectedIndex;
  for (i = 0; i < menu_items.length; i++) {
    menu_items[i].classList.remove('active');
  }
  menu_items[selectedIndex].classList.add('active');
});


  } catch(e) { console.error(e); }
})();
})();
